/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-29 15:44:42
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-12 20:54:54
 * @FilePath: /wemeet-web-activity/src/components/Layout/CustomFooter/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { ReactNode, useContext } from 'react';
import { SPONSOR_PROTOCOL_LINK, PARTICIPANTS_PROTOCOL_LINK } from './data';
import { AppContext } from '@utils/browser/app-context';
import { btnClick, openPage } from './utils';
import beaconReport from '@utils/beacon';
import styles from './index.module.scss';
import classnames from 'classnames';
import { Logo } from './logo';
/**
 * body包裹，用来保证footer能固定底部
 */
export const CustomFooterWrapper = ({ children }: { children: ReactNode }) => (
  <div className={styles['custom-footer-wrapper']}>
    <div className={styles['custom-footer-wrapper-inner']}>{children}</div>
  </div>
);
interface CustomFooterProps {
  classNames?: string;
  alwaysBottom?: boolean;
}

export default function CustomFooter(props: CustomFooterProps) {
  const { classNames, alwaysBottom } = props;
  const { isHost } = useContext(AppContext);
  const getCurYear = () => new Date().getFullYear();

  return (
    <>
      {alwaysBottom && <div className={styles['custom-footer-bottom-placeholder']} />}
      <div
        className={classnames(
          styles['custom-footer'],
          classNames,
          alwaysBottom ? styles['custom-footer-bottom'] : '',
        )}
      >
        <div className={styles.left}>
          <div className={classnames(styles['protocol-link'], 'page-footer-protocol')}>
            {isHost && (
              <>
                <span
                  onClick={() =>
                    btnClick(`${window.location.origin}${SPONSOR_PROTOCOL_LINK}`, true)
                  }
                  className={styles.cursor}
                >
                  腾讯会议活动发起者注册协议
                </span>
                <span className={styles['vertical-line']}> | </span>
              </>
            )}
            <span
              onClick={() =>
                btnClick(`${window.location.origin}${PARTICIPANTS_PROTOCOL_LINK}`, true)
              }
              className={styles.cursor}
            >
              腾讯会议参会者服务协议
            </span>
          </div>
          <div className={classnames(styles.copyright, 'page-footer-copyright')}>
            Copyright © 2018 - <span id="copyrightCtrl">{getCurYear()}</span> Tencent Meeting. All
            Rights Reserved. 腾讯会议 版权所有
          </div>
        </div>
        <span
          className={classnames(styles['tencent-cloud-img'], 'page-footer-cloud-logo')}
          onClick={() => {
            beaconReport('web_foot_tencent_cloud_click', {});
            openPage('https://cloud.tencent.com');
          }}
        >
          {Logo}
        </span>
      </div>
    </>
  );
}
